// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"8ef35e65","36":"96b78c38","98":"0f498745","187":"477a6372","355":"801ab5f7","575":"f573ca6f","628":"41d4914f","670":"bac200c3","789":"65a57c00","800":"2608e25a","892":"209d117a"}[chunkId] + ".chunk.js";
};